import { createEnvService } from './env-service'

export const envService = createEnvService()
